/// <amd-module name="TFS/Admin/Views/GitHubConnection/Constants" />

export const gitHubInvitationProperty: string = "/AllowGitHubInvitations";
export const inviteToggleFeatureFlag: string = "VisualStudio.Services.AdminEngagement.GitHubConnection.GitHubInviteToggle";
